import { render, staticRenderFns } from "./PayrollDashboardSummary.vue?vue&type=template&id=621db3c5&scoped=true"
import script from "./PayrollDashboardSummary.vue?vue&type=script&lang=js"
export * from "./PayrollDashboardSummary.vue?vue&type=script&lang=js"
import style0 from "./PayrollDashboardSummary.vue?vue&type=style&index=0&id=621db3c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621db3c5",
  null
  
)

export default component.exports